export const sessionEnhancedStores = [
  'delivery',
  'giftCard',
  'history',
  'lastGuest',
  'lock',
  'loyaltyProgram',
  'packageState',
  'purchase',
  'queryParams',
  'reschedule',
  'selection',
  'supplementGroups',
  'syndicate',
  'theme',
  'transfer',
  'walkinWaitlist',
  'shopSelection',
  'shopPurchase',
];

export const localEnhancedStores = ['shopCart'];
